export const nav = {
  discover: "さがす",
  live: "配信",
  recommend: "おすすめ",
  chat: "チャット",
  profile: "プロフィール",
  incoming: "着信",
  video: "ビデオ",
  /** coco+ の下部ナビ 2 番目（推しの近況） */
  favorites: "お気に入り",
  messages: "メッセージ",
  board: "掲示板",
} as const;
